import { basePath } from 'src/components/AppRoutes/Enterprise/EnterpriseBasePath';

const base = `${basePath}/:corpid`;
export const EnterprisePaths = {
  base,
  home: `${base}/home`,
  mealCredits: `${base}/meal-credits`,
  reports: `${base}/reports`,
  notFound: `${basePath}/404`,
};
